


































































































































































































































































































































































































import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import { getSeleSubjectsList, getSelectCourseList } from "@/api/globalSearch";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import {
  renewRecordListApi,
  renewRecordCountApi,
  renewRecordListInter,
} from "@/api/renewal";
import { dateFormat } from "@/utils/timeFormat";
import { mixin } from "@/mixin/tabPageInfoMixin";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  components: {
    commonStaffPullDown,
    CommonSearchFormWrapper,
    commonDateRangeSelector,
  },
})
export default class extends Mixins(mixin) {
  searchInfo: any = {
    student_key_word: "",
    course_type: -1,
    record_time: [] as string[],
    renew_time: [] as string[],
    renew_type: -1,
    renew_status: -1,
    sort_type: "desc",
    sort_field: "",
    teacher_id: [],
    teacher_list: [],
    staff_teacher_id: [],
    staff_teacher_list: [],
    course_adviser: [],
    course_adviser_list: [],
  };
  subjectList: any[] = [];
  courseList: any[] = [];
  adviserList: any[] = [];
  staffTeacherList: any[] = [];
  teacherList: any[] = [];
  tableData: any = [];
  statisticsInfo: object = {};
  pageSize: number = 10;
  page: number = 1;
  pageSizeArray = [5, 10, 30, 50, 100];
  total: number = 0;
  created() {
    // 来自续费数据页面
    if (this.$route.query.from === "renewal") {
      this.searchInfo.record_time[0] = this.$route.query.s_time;
      this.searchInfo.record_time[1] = this.$route.query.e_time;
      if (this.$route.query.val === "course_renewed_count") {
        this.searchInfo.renew_status = 2;
      } else if (this.$route.query.val === "renew_amount") {
        this.searchInfo.renew_type = 1;
        this.searchInfo.renew_status = 2;
      } else if (this.$route.query.val === "pre_renew_amount") {
        this.searchInfo.renew_type = 2;
        this.searchInfo.renew_status = 2;
      }
      if (this.$route.query.key === "staff") {
        this.searchInfo.course_adviser = [Number(this.$route.query.id)];
        this.searchInfo.course_adviser_list = [
          {
            staff_id: Number(this.$route.query.id),
            name: this.$route.query.label,
          },
        ];
      }
      if (this.$route.query.key === "edu_teacher") {
        this.searchInfo.staff_teacher_id = [Number(this.$route.query.id)];
        this.searchInfo.staff_teacher_list = [
          {
            staff_id: Number(this.$route.query.id),
            name: this.$route.query.label,
          },
        ];
      }
      if (this.$route.query.key === "teacher") {
        this.searchInfo.teacher_id = [Number(this.$route.query.id)];
        this.searchInfo.teacher_list = [
          {
            staff_id: Number(this.$route.query.id),
            name: this.$route.query.label,
          },
        ];
      }
      if (this.$route.query.key === "course") {
        this.searchInfo.course_id = Number(this.$route.query.id);
        this.searchInfo.courseList = [
          {
            course_id: Number(this.$route.query.id),
            title: this.$route.query.label,
          },
        ];
      }
    }
    this.mixinGetPageInfo("renewRecordSearch");
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
    this.handleSearchSubjectList("");
    this.handleSearchCourseList("");
  }
  handleSearchSubjectList(v: any) {
    getSeleSubjectsList({
      page: 1,
      page_size: 1000,
      title: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.subjectList = res.data.list;
      }
    });
  }
  handleSearchCourseList(v: any) {
    getSelectCourseList({
      page: 1,
      page_size: 1000,
      title: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.courseList = res.data.list;
      }
    });
  }
  getList(val: { page: number; page_size: number; count?: number }) {
    const data: renewRecordListInter = {
      page: val.page,
      page_size: val.page_size,
    };
    if (this.searchInfo.student_key_word) {
      data.key_word = this.searchInfo.student_key_word;
    }
    if (this.searchInfo.subject_id) {
      data.subject_ids = [this.searchInfo.subject_id];
    }
    if (this.searchInfo.course_id) {
      data.course_ids = [this.searchInfo.course_id];
    }
    if (this.searchInfo.course_type !== -1) {
      data.course_type = this.searchInfo.course_type;
    }
    if (this.searchInfo.record_time) {
      data.log_start_date = this.searchInfo.record_time[0];
      data.log_end_date = this.searchInfo.record_time[1];
    }
    if (this.searchInfo.renew_type !== -1) {
      data.renew_type = this.searchInfo.renew_type;
    }
    if (this.searchInfo.course_adviser) {
      data.follow_staff_ids = this.searchInfo.course_adviser;
    }
    if (this.searchInfo.staff_teacher_id) {
      data.edu_teacher_ids = this.searchInfo.staff_teacher_id;
    }
    if (this.searchInfo.teacher_id) {
      data.teacher_ids = this.searchInfo.teacher_id;
    }
    if (this.searchInfo.renew_status !== -1) {
      data.renew_status = this.searchInfo.renew_status;
    }
    if (this.searchInfo.renew_time) {
      data.renew_start_date = this.searchInfo.renew_time[0];
      data.renew_end_date = this.searchInfo.renew_time[1];
    }
    if (this.searchInfo.sort_type) {
      data.sort_type = this.searchInfo.sort_type;
    }
    if (this.searchInfo.sort_field) {
      data.sort_field = this.searchInfo.sort_field;
    }
    if (val.count === 1) {
      renewRecordListApi(data).then((res: any) => {
        if (res.error_code === 0) {
          res.data.list.map((it: any) => {
            if (it.log_time !== 0) {
              it.log_time = dateFormat("YYYY-mm-dd HH:MM", it.log_time * 1000);
            } else {
              it.log_time = "-";
            }
            if (it.renew_time !== 0) {
              it.renew_time = dateFormat("YYYY-mm-dd", it.renew_time * 1000);
            } else {
              it.renew_time = "-";
            }
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
    } else {
      renewRecordListApi(data).then((res: any) => {
        if (res.error_code === 0) {
          res.data.list.map((it: any) => {
            if (it.log_time !== 0) {
              it.log_time = dateFormat("YYYY-mm-dd HH:MM", it.log_time * 1000);
            } else {
              it.log_time = "-";
            }
            if (it.renew_time !== 0) {
              it.renew_time = dateFormat("YYYY-mm-dd", it.renew_time * 1000);
            } else {
              it.renew_time = "-";
            }
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
      renewRecordCountApi(data).then((res: any) => {
        if (res.error_code === 0) {
          res.data.total_amount =
            res.data.total_amount === "0.00" ? "0" : res.data.total_amount;
          res.data.normal_amount =
            res.data.normal_amount === "0.00" ? "0" : res.data.normal_amount;
          res.data.ahead_amount =
            res.data.ahead_amount === "0.00" ? "0" : res.data.ahead_amount;
          this.statisticsInfo = res.data;
        }
      });
    }
  }
  clickSort(e: { order: string; prop: string }) {
    this.searchInfo.sort_field = e.prop;
    if (e.order == "descending") {
      this.searchInfo.sort_type = "desc";
    } else if (e.order == "ascending") {
      this.searchInfo.sort_type = "asc";
    } else {
      this.searchInfo.sort_type = "";
    }
    this.getList({
      page: 1,
      page_size: this.pageSize,
      count: 1,
    });
  }
  handleSearch() {
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  goStudentDetail(v: any) {
    this.mixinSavePageInfo("renewRecordSearch");
    this.$router.push({
      name: "studyDetails",
      query: {
        id: v.student_id,
      },
    });
  }
  goOrderDetail(v: any) {
    this.mixinSavePageInfo("renewRecordSearch");
    if (v.order_item_id) {
      this.$router.push({
        name: "orderManageDetail",
        query: {
          sid: v.student_id,
          id: v.order_id,
        },
      });
    }
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
      count: 1,
    });
  }
  handlePagerChange(e: number) {
    this.page = e;
    this.getList({
      page: e,
      page_size: this.pageSize,
      count: 1,
    });
  }
  handleSearchReset() {
    this.searchInfo = {
      student_key_word: "",
      course_type: -1,
      record_time: [],
      renew_time: [],
      renew_type: -1,
      renew_status: -1,
      sort_type: "desc",
      sort_field: "",
      teacher_id: [],
      teacher_list: [],
      staff_teacher_id: [],
      staff_teacher_list: [],
      course_adviser: [],
      course_adviser_list: [],
    };
    this.handleSearch();
  }
}
